<template>
  <div class="d-flex align-items-center justify-content-center h-100">
    <div :class="['ripple', small ? 'ripple--small': '']">
      <div />
      <div />
    </div>
    <strong v-if="displayLoading" class="loading-text">{{ $t('Loading...') }}</strong>
    <strong v-if="saving" class="loading-text">{{ $t('Saving...') }}</strong>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: ['displayLoading', 'saving', 'small'],
}
</script>

<style scoped lang="scss">

.loading-text {
  height: 35px;
  font-weight: 700;
}

.ripple {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
    & div {
      position: absolute;
      border: 2px solid $theme-primary;
      opacity: 1;
      border-radius: 50%;
      animation: ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
      &:nth-child(2) {
        animation-delay: -1s;
      }
    }
    &--small {
      width: 30px;
      height: 30px;
      & div {
        animation: ripple-small 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
      }
    }
}

@keyframes ripple {
  0% {
    top: 26px;
    left: 26px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 52px;
    height: 52px;
    opacity: 0;
  }
}
@keyframes ripple-small {
  0% {
    top: 13px;
    left: 13px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 26px;
    height: 26px;
    opacity: 0;
  }
}
</style>
